module.exports = __webpack_public_path__ + "static/media/strawberryFrosting.36c4a1f4.jpg";